import { Controller } from "@hotwired/stimulus"
import { put } from "@rails/request.js"

// Connects to data-controller="ticket-check-in" on an order-view ticket row.
// Toggles a purchased ticket's check-in via the same JSON PUT endpoint the
// attendees datatable uses, then updates the row in place: number bubble <->
// green check, "Check in" <-> "Undo", and the "Checked in …" line + green border.
export default class extends Controller {
  static targets = ["button", "bubble", "checkedLine"]
  static values = { url: String, checkedIn: Boolean, whenText: String }

  async toggle() {
    if (this.busy) return
    this.busy = true
    this.buttonTarget.classList.add("is-loading")

    try {
      const response = await put(this.urlValue, { responseKind: "json" })
      const data = response.ok ? await response.json : await response.json
      if (response.ok && data.success) {
        this.apply(data.checked_in)
        if (data.message) window.displayFlashMessage("success", data.message)
      } else {
        window.displayFlashMessage("error", (data && data.message) || "Failed to update check-in")
      }
    } catch (e) {
      window.displayFlashMessage("error", "Failed to update check-in")
    } finally {
      this.busy = false
      this.buttonTarget.classList.remove("is-loading")
    }
  }

  // Reflect the new state in the row without a full reload.
  apply(checkedIn) {
    this.checkedInValue = checkedIn
    this.element.classList.toggle("ticket-row-wrapper--checked-in", checkedIn)

    // Let the order's check-in summary recompute its counts/progress.
    document.dispatchEvent(new CustomEvent("ticket-check-in:toggled", {
      detail: { checkedIn },
    }))

    if (this.hasBubbleTarget) {
      this.bubbleTarget.classList.toggle("ticket-number-bubble--checked", checkedIn)
      this.bubbleTarget.innerHTML = checkedIn ? this.bubbleTarget.dataset.checkedIcon : this.bubbleTarget.dataset.number
    }

    if (this.hasCheckedLineTarget) {
      this.checkedLineTarget.hidden = !checkedIn
    }

    // Swap the button label/style. The "when" line only refreshes on reload
    // (we don't get the server timestamp back in the JSON), so on a fresh
    // check-in show a generic "Checked in" line until reload fills the time.
    this.buttonTarget.textContent = checkedIn
      ? this.buttonTarget.dataset.undoLabel
      : this.buttonTarget.dataset.checkInLabel
    this.buttonTarget.classList.toggle("ticket-check-in-btn--undo", checkedIn)
  }
}
